import { IInfrastructureData } from '../../../types/map';

export function getInfrastructureByYear(
  geoObjectsMapByYear: Map<number, IInfrastructureData>,
  year: number,
): IInfrastructureData {
  return geoObjectsMapByYear.get(year) || { geoObjectsData: [], futureTypes: [] };
}
